module.exports = {
    "baseUrl": "https://grameenguru.grameenfoundation.in/api/v1/grameen/",
    "apiBaseUrl": "https://grameenguru.grameenfoundation.in",
    "systemName": "Dev"
}